export default __webpack_public_path__ + "static/media/appointments_5.6832862b.jpg";